export const groupedTools = {
  AI: [
    {
      name: "Multi-Model AI Chat Playground",
      nameKey: "ai_model_playground_name",
      description:
        "Compare AI models side-by-side — test prompts across OpenAI GPT, Google Gemini, Groq, and more from one interface.",
      descriptionKey: "ai_model_playground_desc",
      path: "/tools/multi-model-playground",
      isPaid: true,
      loginRequired: true,
      splashImageUrl: "https://quto.dev/splash_multi_model_ai_tester.png",
      icon: "/images/Multi-Model-AI-Playground.png"
    },
    {
      name: "Speech to Text AI Converter",
      nameKey: "multi_model_transcription_name",
      description:
        "Transcribe audio to text using multiple AI models — compare accuracy from OpenAI Whisper and Groq side-by-side.",
      descriptionKey: "multi_model_transcription_desc",
      path: "/tools/multi-model-transcription",
      isPaid: true,
      loginRequired: true,
      splashImageUrl: "https://quto.dev/splash_multi_model_transcription_tool.png",
      icon: "/images/Multi-Model-Transcription-Tool.png"
    },
    {
      name: "AI Image Generator Online",
      nameKey: "multi_model_image_name",
      description:
        "Generate AI images with DALL-E and Google Gemini — compare outputs from multiple models side-by-side.",
      descriptionKey: "multi_model_image_desc",
      path: "/tools/multi-model-image-generator",
      isPaid: true,
      loginRequired: true,
      splashImageUrl: "https://quto.dev/splash_multi_model_image_generator.png",
      icon: "/images/Multi-Model-Image-Generator.png"
    },
    {
      name: "AI Code Reviewer",
      nameKey: "code_reviewer_name",
      description: "Get instant AI-powered code reviews — paste any code and receive suggestions for bugs, best practices, and optimizations.",
      descriptionKey: "code_reviewer_desc",
      path: "/tools/code-reviewer",
      isPaid: true,
      loginRequired: true,
      splashImageUrl: "https://quto.dev/splash_code_reviewer.png",
      icon: "/images/Code-Reviewer.png"
    },
    {
      name: "AI Token Counter",
      nameKey: "token_counter_name",
      description:
        "Count GPT tokens in your text instantly. Plan prompts, estimate API costs, and stay within context limits.",
      descriptionKey: "token_counter_desc",
      path: "/tools/token-counter",
      splashImageUrl: "https://quto.dev/splash_token_counter.png",
      icon: "/images/Token-Counter.png"
    },
    {
      name: "AI Meme Generator",
      nameKey: "meme_creator_name",
      description: "Create memes with AI — describe your idea and let multiple AI models generate the image.",
      descriptionKey: "meme_creator_desc",
      path: "/tools/meme-creator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      isPaid: true,
      loginRequired: true,
      icon: "/images/MemeCreator.png"
    }
  ],
  URL: [
    {
      name: "URL Encoder Online",
      nameKey: "url_encoder_name",
      description:
        "Free online URL encoder — convert text to percent-encoded URL-safe format instantly.",
      descriptionKey: "url_encoder_desc",
      path: "/tools/url-encoder",
      splashImageUrl: "https://quto.dev/splash_url_encoder.png",
      icon: "/images/URL-Encoder.png"
    },
    {
      name: "URL Decoder Online",
      nameKey: "url_decoder_name",
      description:
        "Free online URL decoder — convert percent-encoded URLs back to readable text instantly.",
      descriptionKey: "url_decoder_desc",
      path: "/tools/url-decoder",
      splashImageUrl: "https://quto.dev/splash_url_decoder.png",
      icon: "/images/URL-Decoder.png"
    },
    {
      name: "URL Query Parameter Editor",
      nameKey: "query_param_editor_name",
      description:
        "Add, edit, or remove URL query parameters visually. Build and test API endpoints without manual string editing.",
      descriptionKey: "query_param_editor_desc",
      path: "/tools/query-param-editor",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Query-Param-Editor.png"
    },
    {
      name: "URL Parser",
      nameKey: "url_parser_name",
      description:
        "Break any URL into its parts — protocol, auth, host, port, path segments, query parameters and hash. Flags IDN/punycode hostnames and default scheme ports. Fully client-side.",
      descriptionKey: "url_parser_desc",
      path: "/tools/url-parser",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Query-Param-Editor.png"
    },
    {
      name: "Punycode Converter",
      nameKey: "punycode_name",
      description:
        "Convert internationalized domain names between Unicode (münchen.de) and ASCII punycode (xn--mnchen-3ya.de). Works on bare domains or full URLs, label-by-label. Fully client-side.",
      descriptionKey: "punycode_desc",
      path: "/tools/punycode-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/URL-Encoder.png"
    },
    {
      name: "Web Page Scraper",
      nameKey: "url_scraper_name",
      path: "/tools/url-scraper",
      description: "Extract HTML or plain text content from any URL for data extraction and research.",
      descriptionKey: "url_scraper_desc",
      isPaid: true,
      loginRequired: true,
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/URL-Scraper.png"
    },
    {
      name: "File to Shareable Link",
      nameKey: "file_to_link_name",
      description: "Upload any file and get an instant shareable link.",
      descriptionKey: "file_to_link_desc",
      path: "/tools/file-to-link",
      loginRequired: true,
      isPaid: true,
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/File-To-Link.png"
    },
    {
      name: "Clipboard to Shareable Link",
      nameKey: "clipboard_to_link_name",
      description: "Paste images or text from clipboard and get a shareable link instantly.",
      descriptionKey: "clipboard_to_link_desc",
      path: "/tools/clipboard-to-link",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Clipboard-To-Link.png",
      loginRequired: true,
      isPaid: true,
    }
  ],
  SEO: [
    {
      name: "Keyword Research Tool",
      nameKey: "kw_name",
      description:
        "Find top keywords with real Google search data. Expand a seed keyword into hundreds of related keywords with average monthly searches, 12-month trend, competition and top-of-page bid range from Google Keyword Planner, or pull metrics for your own keyword list. Filter, sort and export to CSV.",
      descriptionKey: "kw_desc",
      path: "/tools/keyword-research",
      isPaid: true,
      loginRequired: true,
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/URL-Scraper.png"
    },
  ],
  TEXT: [
    {
      name: "Remove Line Breaks Online",
      nameKey: "remove_line_breaks_name",
      description:
        "Remove unwanted line breaks from text instantly. Replace with spaces, commas, or custom separators.",
      descriptionKey: "remove_line_breaks_desc",
      path: "/tools/remove-line-breaks",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Remove-Line-Breaks.png"
    },
    {
      name: "String Escape Renderer",
      nameKey: "render_string_name",
      description:
        "Convert escaped characters like \\n, \\t, and \\r into actual formatting. Preview how raw strings render.",
      descriptionKey: "render_string_desc",
      path: "/tools/render-string",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Render-String.png"
    },
    {
      name: "Markdown Preview Online",
      nameKey: "render_markdown_name",
      description:
        "Free online Markdown editor with live preview. Paste Markdown and see rendered HTML in real time.",
      descriptionKey: "render_markdown_desc",
      path: "/tools/render-markdown",
      splashImageUrl: "https://quto.dev/splash_render_markdown.png",
      icon: "/images/Render-Markdown.png"
    },
    {
      name: "Text Diff Checker Online",
      nameKey: "text_compare_name",
      description:
        "Compare two texts side-by-side with highlighted differences. Free online diff tool for code review and proofreading.",
      descriptionKey: "text_compare_desc",
      path: "/tools/text-compare",
      splashImageUrl: "https://quto.dev/splash_text_compare.png",
      icon: "/images/Text-Compare.png"
    },
    {
      name: "Word & Character Counter",
      nameKey: "text_counter_name",
      description:
        "Count words, characters, sentences, and paragraphs instantly. Free online text analyzer.",
      descriptionKey: "text_counter_desc",
      path: "/tools/text-counter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Text-Counter.png"
    },
    {
      name: "Text Case Converter",
      nameKey: "case_converter_name",
      description:
        "Convert text between camelCase, PascalCase, snake_case, kebab-case, CONSTANT_CASE, Title Case, and more. Handles existing case boundaries and Unicode — fully client-side and private.",
      descriptionKey: "case_converter_desc",
      path: "/tools/case-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Case-Converter.png"
    },
    {
      name: "Regex Tester Online",
      nameKey: "regex_tester_name",
      description:
        "Test JavaScript regular expressions live — see matches, capture groups, and replacements highlighted in your test text. Fully client-side and private.",
      descriptionKey: "regex_tester_desc",
      path: "/tools/regex-tester",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Regex-Tester.png"
    },
    {
      name: "Base64 Encoder / Decoder",
      nameKey: "base64_codec_name",
      description:
        "Encode text to Base64 or decode Base64 back to text. Supports the standard alphabet and the URL-safe variant, handles Unicode correctly, and runs fully client-side.",
      descriptionKey: "base64_codec_desc",
      path: "/tools/base64-encoder-decoder",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/URL-Encoder.png"
    },
    {
      name: "Base32 Encoder / Decoder",
      nameKey: "base32_codec_name",
      description:
        "Encode text to Base32 or decode Base32 back to text. Supports the RFC 4648 standard and hex (base32hex) alphabets, optional padding, is case-insensitive on decode, and runs fully client-side.",
      descriptionKey: "base32_codec_desc",
      path: "/tools/base32-encoder-decoder",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/URL-Encoder.png"
    },
    {
      name: "URL Slug Generator",
      nameKey: "slugifier_name",
      description:
        "Turn any title or sentence into a clean, URL-safe slug. Choose your separator, control casing, strip accents, and limit length — fully client-side and private.",
      descriptionKey: "slugifier_desc",
      path: "/tools/slugifier",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/URL-Encoder.png"
    },
    {
      name: "HTML Entity Encoder / Decoder",
      nameKey: "html_entity_codec_name",
      description:
        "Escape HTML special characters (& < > \" ') as entities, or decode entities back to plain text. Supports named, numeric, and hex entities and runs fully client-side.",
      descriptionKey: "html_entity_codec_desc",
      path: "/tools/html-entity-encoder-decoder",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/URL-Encoder.png"
    },
    {
      name: "CSV / JSON Converter",
      nameKey: "csv_json_name",
      description:
        "Convert CSV to JSON or JSON to CSV in your browser. Choose a delimiter (comma, semicolon, tab, pipe), control header and type inference, and copy or download the result — fully client-side and private.",
      descriptionKey: "csv_json_desc",
      path: "/tools/csv-json-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/JSON-Formatter.png"
    },
    {
      name: "Lorem Ipsum Generator",
      nameKey: "lorem_ipsum_name",
      description:
        "Generate placeholder Lorem Ipsum text instantly — choose paragraphs, sentences, or words and pick the count. Perfect for mockups, design comps, and test data. Fully client-side and private.",
      descriptionKey: "lorem_ipsum_desc",
      path: "/tools/lorem-ipsum-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Render-String.png"
    },
    {
      name: "Hash Generator (SHA-1 / SHA-256 / SHA-384 / SHA-512)",
      nameKey: "hash_generator_name",
      description:
        "Compute SHA-1, SHA-256, SHA-384, and SHA-512 cryptographic hashes from any text. Output as hex or base64, compare against an expected digest, and verify checksums entirely in your browser.",
      descriptionKey: "hash_generator_desc",
      path: "/tools/hash-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Password-Generator.png"
    },
    {
      name: "JSON / YAML Converter",
      nameKey: "json_yaml_name",
      description:
        "Convert JSON to YAML or YAML to JSON in your browser. Pick an indent width, round-trip nested objects and arrays, and copy or download the result — fully client-side and private.",
      descriptionKey: "json_yaml_desc",
      path: "/tools/json-yaml-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/JSON-Formatter.png"
    },
    {
      name: "Markdown Table Generator",
      nameKey: "markdown_table_name",
      description:
        "Build Markdown tables visually — edit headers and cells in a spreadsheet-style grid, pick per-column alignment, and copy GitHub-flavored Markdown ready to paste into READMEs, docs, and issues. Fully client-side and private.",
      descriptionKey: "markdown_table_desc",
      path: "/tools/markdown-table-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Render-Markdown.png"
    },
    {
      name: "XML Formatter & Minifier",
      nameKey: "xml_formatter_name",
      description:
        "Pretty-print or minify XML in your browser — pick a 2-space, 4-space, or tab indent, optionally strip comments when minifying, and copy or download the result. Validates well-formedness, preserves CDATA, comments, and the XML declaration. Fully client-side and private.",
      descriptionKey: "xml_formatter_desc",
      path: "/tools/xml-formatter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/JSON-Formatter.png"
    },
    {
      name: "Markdown Table of Contents Generator",
      nameKey: "md_toc_name",
      description:
        "Generate a clean Markdown table of contents from your README or docs — pick the heading level range, choose GitHub or GitLab anchor slugs, get numbered or plain bullets, and copy the result. Handles fenced code blocks correctly so headings inside code are skipped. Fully client-side and private.",
      descriptionKey: "md_toc_desc",
      path: "/tools/markdown-toc-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Render-Markdown.png"
    },
    {
      name: "Unicode Character Inspector",
      nameKey: "unicode_inspector_name",
      description:
        "Inspect any string character by character — see codepoint (U+XXXX), decimal, UTF-8 bytes, JavaScript \\u escape, and HTML entity for each glyph. Reveals invisible characters like zero-width joiners, BOM, and RTL marks so you can debug Unicode bugs fast. Fully client-side and private.",
      descriptionKey: "unicode_inspector_desc",
      path: "/tools/unicode-inspector",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Render-String.png"
    },
    {
      name: "Line Sorter & Deduplicator",
      nameKey: "line_sorter_name",
      description:
        "Sort lines alphabetically, numerically (natural order), by length, reverse them, or shuffle. Remove duplicates, trim whitespace, and drop empty lines — fully client-side and private.",
      descriptionKey: "line_sorter_desc",
      path: "/tools/line-sorter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Render-String.png"
    },
    {
      name: "Roman Numeral Converter",
      nameKey: "roman_numeral_name",
      description:
        "Convert numbers to Roman numerals or Roman numerals back to numbers (1–3999). Handles subtractive notation (IV, IX, XL, XC, CD, CM), flags non-canonical input, and runs fully client-side.",
      descriptionKey: "roman_numeral_desc",
      path: "/tools/roman-numeral-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Render-String.png"
    },
  ],
  HTTP: [
    {
      name: "Online API Tester",
      nameKey: "api_tester_name",
      description:
        "Test REST APIs directly in your browser — send GET, POST, PUT, DELETE requests and inspect responses.",
      descriptionKey: "api_tester_desc",
      path: "/tools/api-tester",
      splashImageUrl: "https://quto.dev/splash_api_tester.png",
      icon: "/images/API-Tester.png"
    },
    {
      name: "Request Inspector (Webhook Tester)",
      nameKey: "ri_name",
      description:
        "Get a temporary webhook URL and watch incoming HTTP requests live — any method, headers, query, JSON, form data and uploaded images. Endpoints and captured data are deleted after 1 hour.",
      descriptionKey: "ri_desc",
      path: "/tools/request-inspector",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/API-Tester.png"
    },
    {
      name: "Application Error Logger",
      nameKey: "error_logging_name",
      description: "Monitor and track application errors in real time. A lightweight error logging system with REST API ingestion.",
      descriptionKey: "error_logging_desc",
      path: "/tools/error-logging",
      splashImageUrl: "https://quto.dev/splash_error_logging.png",
      icon: "/images/Error-Logging.png",
      loginRequired: true,
      isPaid: true
    },
    {
      name: "JWT Decoder Online",
      nameKey: "jwt_decoder_name",
      description:
        "Decode JWT tokens instantly in your browser. Inspect header, payload, and signature — with human-readable expiry and issued-at timestamps. Fully client-side and private.",
      descriptionKey: "jwt_decoder_desc",
      path: "/tools/jwt-decoder",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/JWT-Decoder-Online.png"
    },
    {
      name: "TOTP Authenticator Code Generator",
      nameKey: "totp_name",
      description:
        "Generate Time-based One-Time Passwords (RFC 6238) from a base32 secret — pick SHA-1/256/512, 6–8 digits, and 15/30/60-second periods. Live countdown plus previous and next codes. Fully client-side and private.",
      descriptionKey: "totp_desc",
      path: "/tools/totp-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/JWT-Decoder-Online.png"
    },
    {
      name: "HMAC Generator",
      nameKey: "hmac_name",
      description:
        "Compute HMAC signatures with SHA-1, SHA-256, SHA-384, or SHA-512 — accept text, hex, or base64 keys, output as hex/base64/base64url, and verify against an expected signature. Useful for webhook signatures (GitHub, Stripe, Slack). Fully client-side and private.",
      descriptionKey: "hmac_desc",
      path: "/tools/hmac-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/JWT-Decoder-Online.png"
    },
    {
      name: "IPv4 CIDR / Subnet Calculator",
      nameKey: "cidr_calc_name",
      description:
        "Compute network and broadcast addresses, usable host range, subnet mask, wildcard mask, and IP class for any IPv4 CIDR block. Detects RFC 1918 private ranges — fully client-side and private.",
      descriptionKey: "cidr_calc_desc",
      path: "/tools/cidr-calculator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Error-Logging.png"
    },
    {
      name: "HTTP Status Code Lookup",
      nameKey: "http_status_name",
      description:
        "Searchable reference for every HTTP status code — 1xx through 5xx, including WebDAV and modern extensions. Filter by class, see the canonical name, when to return each code, and copy with one click. Fully client-side and private.",
      descriptionKey: "http_status_desc",
      path: "/tools/http-status-codes",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Error-Logging.png"
    },
    {
      name: "MIME Type Lookup",
      nameKey: "mime_lookup_name",
      description:
        "Searchable reference for common MIME (media) types — find the right Content-Type for a file extension, decode an unfamiliar type, and copy with one click. Covers JSON, XML, YAML, the Office Open XML family, modern image and video formats, fonts, and more. Fully client-side and private.",
      descriptionKey: "mime_lookup_desc",
      path: "/tools/mime-type-lookup",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Error-Logging.png"
    }
  ],
  JAVASCRIPT: [
    {
      name: "JSON Formatter & Viewer",
      nameKey: "json_formatter_name",
      description:
        "Format, validate, and beautify JSON online with syntax highlighting and collapsible tree view.",
      descriptionKey: "json_formatter_desc",
      path: "/tools/json-formatter",
      splashImageUrl: "https://quto.dev/splash_json_formatter.png",
      icon: "/images/JSON-Formatter.png"
    },
    {
      name: "JavaScript Playground Online",
      nameKey: "js_playground_name",
      description:
        "Write and run JavaScript code in your browser with instant output. Free online JS editor and console.",
      descriptionKey: "js_playground_desc",
      path: "/tools/js-playground",
      splashImageUrl: "https://quto.dev/splash_javascript_playground.png",
      icon: "/images/JavaScript-Playground.png"
    },
    {
      name: "UUID Generator (v4 & v7)",
      nameKey: "uuid_gen_name",
      description:
        "Generate cryptographically random UUID v4 and time-ordered UUID v7 in your browser. Bulk-create up to 100 IDs and copy them in one click — fully client-side and private.",
      descriptionKey: "uuid_gen_desc",
      path: "/tools/uuid-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/UUID-Generator.png"
    },
    {
      name: "ULID Generator",
      nameKey: "ulid_gen_name",
      description:
        "Generate 26-character Crockford Base32 ULIDs in your browser. Lexicographically sortable, 128-bit, URL-safe — bulk-create up to 100 IDs and copy them in one click, fully client-side and private.",
      descriptionKey: "ulid_gen_desc",
      path: "/tools/ulid-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/UUID-Generator.png"
    },
    {
      name: "MongoDB ObjectId Inspector",
      nameKey: "mongo_oid_name",
      description:
        "Decode 24-hex-character MongoDB ObjectIds into their embedded creation timestamp, random per-process value, and counter. Also build an ObjectId from any date for _id range queries — fully client-side and private.",
      descriptionKey: "mongo_oid_desc",
      path: "/tools/mongo-objectid-inspector",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/UUID-Generator.png"
    },
    {
      name: "Color Format Converter",
      nameKey: "color_converter_name",
      description:
        "Convert between HEX, RGB, and HSL color formats with a live preview. Supports alpha channels and the HTML color picker — fully client-side and private.",
      descriptionKey: "color_converter_desc",
      path: "/tools/color-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Color-Converter.png"
    },
    {
      name: "Secure Password Generator",
      nameKey: "password_gen_name",
      description:
        "Generate strong, random passwords in your browser. Pick length and character classes, exclude ambiguous characters, and bulk-create up to 50 passwords — fully client-side and private.",
      descriptionKey: "password_gen_desc",
      path: "/tools/password-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Password-Generator.png"
    },
    {
      name: "Unix Chmod Calculator",
      nameKey: "chmod_calculator_name",
      description:
        "Convert between octal (e.g. 755), symbolic (rwxr-xr-x), and per-class checkboxes for Unix file permissions. Includes setuid, setgid, sticky bit, and common presets — fully client-side and private.",
      descriptionKey: "chmod_calculator_desc",
      path: "/tools/chmod-calculator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/URL-Encoder.png"
    },
    {
      name: "Number Base Converter",
      nameKey: "number_base_name",
      description:
        "Convert numbers between binary, octal, decimal, and hexadecimal in real time. Supports BigInt-sized values, optional fixed bit widths (8/16/32/64), and runs fully client-side.",
      descriptionKey: "number_base_desc",
      path: "/tools/number-base-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Color-Converter.png"
    },
    {
      name: "JSON to TypeScript Interface Generator",
      nameKey: "json_to_ts_name",
      description:
        "Paste any JSON and instantly get TypeScript interfaces (or type aliases) for it. Infers primitives, nested objects, arrays, unions, optional fields across array items, and quotes invalid property names. Fully client-side and private.",
      descriptionKey: "json_to_ts_desc",
      path: "/tools/json-to-typescript",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/JSON-Formatter.png"
    },
    {
      name: "Byte Size Converter",
      nameKey: "byte_size_name",
      description:
        "Convert between bytes, kilobytes, megabytes, gigabytes, terabytes, petabytes — and their binary (KiB, MiB, GiB) and network bit (kbit, Mbit, Gbit) counterparts. See every equivalent at a glance plus a human-readable summary in SI and IEC units. Fully client-side and private.",
      descriptionKey: "byte_size_desc",
      path: "/tools/byte-size-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Color-Converter.png"
    },
    {
      name: "JSON Path Tester",
      nameKey: "json_path_name",
      description:
        "Query JSON documents with JSONPath expressions in your browser — supports root ($), dot and bracket property access, wildcards (*), recursive descent (..), numeric indexes, slices, and unions. See all matches with live evaluation and copy the result. Fully client-side and private.",
      descriptionKey: "json_path_desc",
      path: "/tools/json-path-tester",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/JSON-Formatter.png"
    },
    {
      name: "SemVer Comparator",
      nameKey: "semver_cmp_name",
      description:
        "Parse and compare two Semantic Versioning 2.0.0 strings in your browser. See each version broken down into major, minor, patch, prerelease and build metadata, and get a spec-compliant precedence verdict with the exact identifier that drove the comparison — fully client-side and private.",
      descriptionKey: "semver_cmp_desc",
      path: "/tools/semver-comparator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/UUID-Generator.png"
    },
    {
      name: "Luhn Validator & Check Digit Generator",
      nameKey: "luhn_name",
      description:
        "Validate credit card numbers, IMEIs and other Luhn-protected identifiers, or generate the correct Luhn check digit for a partial number. Detects common card brands (Visa, Mastercard, Amex, Discover, Diners, JCB, UnionPay), flags length mismatches, and runs fully client-side.",
      descriptionKey: "luhn_desc",
      path: "/tools/luhn-validator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/UUID-Generator.png"
    },
  ],
  HTML: [
    {
        name: "HTML/CSS Live Editor",
        nameKey: "html_css_playground",
        description: "Write and preview HTML/CSS in real time with instant live rendering.",
        descriptionKey: "html_css_playground_description",
        path: "/tools/html-playground",
        icon: "/images/Html-Playground.png",
        isPaid: false,
    },
    {
      name: "CSS Unit Converter",
      nameKey: "css_unit_name",
      description:
        "Convert between CSS length units — px, rem, em, pt, pc, in, cm, and mm — with a configurable root and parent font size. See every equivalent at a glance and copy the formatted value in one click. Fully client-side and private.",
      descriptionKey: "css_unit_desc",
      path: "/tools/css-unit-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Html-Playground.png"
    },
    {
      name: "Color Contrast Checker (WCAG)",
      nameKey: "color_contrast_name",
      description:
        "Check WCAG 2.x contrast ratios between foreground and background colors. Live preview, AA/AAA pass/fail for normal and large text, UI component (1.4.11) check, and alpha-aware compositing — fully client-side and private.",
      descriptionKey: "color_contrast_desc",
      path: "/tools/color-contrast-checker",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Color-Converter.png"
    },
    {
      name: "CSS Box Shadow Generator",
      nameKey: "box_shadow_name",
      description:
        "Design CSS box-shadow values visually — drag sliders for offset, blur, spread, and opacity, layer multiple shadows, toggle inset, pick from curated presets, preview against light, dark, or checker backgrounds, and copy production-ready CSS. Fully client-side and private.",
      descriptionKey: "box_shadow_desc",
      path: "/tools/box-shadow-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Html-Playground.png"
    },
    {
      name: "CSS Gradient Generator",
      nameKey: "gradient_name",
      description:
        "Build CSS linear and radial gradients visually — pick stops, drag positions, set angle or radial shape and origin, toggle repeating gradients, choose from curated presets, preview on light, dark, or checker backgrounds, and copy production-ready CSS. Fully client-side and private.",
      descriptionKey: "gradient_desc",
      path: "/tools/css-gradient-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Html-Playground.png"
    },
    {
      name: "CSS clamp() Generator",
      nameKey: "clamp_name",
      description:
        "Generate fluid-responsive CSS clamp() values for typography and spacing. Set a min and max size, the viewport range you want them to scale across, choose rem or px output, preview the result as the viewport changes, and copy production-ready CSS. Fully client-side and private.",
      descriptionKey: "clamp_desc",
      path: "/tools/css-clamp-generator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Html-Playground.png"
    },
    {
      name: "CSS Specificity Calculator",
      nameKey: "css_spec_name",
      description:
        "Calculate CSS Selectors Level 4 specificity for any selector list. Break every selector down into ID, class/attribute/pseudo-class, and type/pseudo-element counts, see which one wins the cascade, and copy the (a,b,c) value — with correct handling of :is(), :not(), :has(), :where(), and :nth-child(An+B of S). Fully client-side and private.",
      descriptionKey: "css_spec_desc",
      path: "/tools/css-specificity-calculator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Html-Playground.png"
    },
  ],
  EMAIL: [
    {
      name: "SMTP Server Tester",
      nameKey: "smtp_tester_name",
      description:
        "Test SMTP server connectivity and send test emails with your credentials. Verify email delivery setup.",
      descriptionKey: "smtp_tester_desc",
      path: "/tools/smtp-tester",
      splashImageUrl: "https://quto.dev/splash_smtp_tester.png",
      icon: "/images/SMTP-Tester.png"
    },
    {
      name: "Email Address Verifier",
      nameKey: "email_verifier_name",
      description:
        "Verify if an email address is real — checks syntax, domain MX records, and SMTP server existence.",
      descriptionKey: "email_verifier_desc",
      path: "/tools/email-verifier",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Email-Verifier.png"
    },
  ],
  TIME: [
    {
      name: "Time Zone Converter",
      nameKey: "timezone_converter_name",
      description:
        "Convert time across multiple time zones instantly. Essential for scheduling remote meetings and global coordination.",
      descriptionKey: "timezone_converter_desc",
      path: "/tools/timezone-converter",
      splashImageUrl: "https://quto.dev/splash_timezone_convertor.png",
      icon: "/images/Timezone-Converter.png"
    },
    {
      name: "Cron Expression Translator",
      nameKey: "cron_translator_name",
      description:
        "Translate cron expressions into plain English, see the next 5 run times in your local time and UTC, and try common presets like @daily and @hourly. Fully client-side and private.",
      descriptionKey: "cron_translator_desc",
      path: "/tools/cron-translator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Cron-Translator.png"
    },
    {
      name: "Unix Timestamp Converter",
      nameKey: "timestamp_converter_name",
      description:
        "Convert Unix timestamps (seconds or milliseconds) to ISO, UTC and local dates — and back the other way. Fully client-side and private.",
      descriptionKey: "timestamp_converter_desc",
      path: "/tools/timestamp-converter",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Timezone-Converter.png"
    },
    {
      name: "Date Difference Calculator",
      nameKey: "date_diff_name",
      description:
        "Calculate the duration between two dates as a calendar breakdown (years, months, days) and as totals in weeks, days, hours, minutes, and seconds. Counts business days (Mon–Fri) and adds or subtracts an offset from any date. Fully client-side and private.",
      descriptionKey: "date_diff_desc",
      path: "/tools/date-difference-calculator",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Timezone-Converter.png"
    },
  ],
  IMAGE: [
    {
      name: "Image Resizer Online",
      nameKey: "image_resizer_name",
      description:
        "Resize PNG, JPG, and WebP images to exact dimensions or scale proportionally online.",
      descriptionKey: "image_resizer_desc",
      path: "/tools/image-resizer",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Image-Resizer.png"
    },
    {
      name: "Free AI Background Remover",
      nameKey: "background_remover_name",
      description: "Remove image backgrounds instantly with AI — runs entirely in your browser. 100% free, no uploads, fully private.",
      descriptionKey: "background_remover_desc",
      path: "/tools/background-remover",
      isPaid: false,
      loginRequired: false,
      splashImageUrl: "https://quto.dev/splash_background_remover.png",
      icon: "/images/Background-Remover.png"
    },
    {
      name: "Image to Text (OCR)",
      nameKey: "ocr_image_name",
      description: "Extract text from images using AI-powered OCR. Upload any image and get accurate, editable text instantly.",
      descriptionKey: "ocr_image_desc",
      path: "/tools/ocr-image",
      loginRequired: true,
      isPaid: true,
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/OCR-Image.png"
    },
    {
      name: "Free QR Code Generator",
      nameKey: "qr_code_generator_name",
      description: "Generate custom QR codes for free — enter any URL, text, or content and download as PNG or SVG.",
      descriptionKey: "qr_code_generator_desc",
      path: "/tools/qr-code-generator",
      splashImageUrl: "https://quto.dev/splash_qr_code_generator.png",
      icon: "/images/QR-Code-Generator.png"
    },
  ],
  PDF: [
    {
      name: "PDF to Text Converter Online",
      nameKey: "pdf_to_text_name",
      description:
        "Extract text from PDF files online using OCR technology. Convert scanned documents into editable plain text.",
      descriptionKey: "pdf_to_text_desc",
      path: "/tools/pdf-to-text-converter",
      loginRequired: true,
      isPaid: true,
      splashImageUrl: "https://quto.dev/splash_pdf_to_text_2.png",
      icon: "/images/PDF-To-Text-Converter.png"
    },

    {
      name: "PDF to CSV Converter Online",
      nameKey: "pdf_to_csv_name",
      description:
        "Extract tables from PDF files and convert to CSV format online. Digitize spreadsheets and financial reports.",
      descriptionKey: "pdf_to_csv_desc",
      path: "/tools/pdf-to-csv-converter",
      loginRequired: true,
      isPaid: true,
      splashImageUrl: "https://quto.dev/splash_pdf_to_csv.png",
      icon: "/images/PDF-To-CSV-Converter.png"
    },

    {
      name: "PDF to HTML Converter Online",
      nameKey: "pdf_to_html_name",
      description:
        "Convert PDF files to clean, editable HTML online. Preserve formatting and layout for web publishing.",
      descriptionKey: "pdf_to_html_desc",
      path: "/tools/pdf-to-html-converter",
      loginRequired: true,
      isPaid: true,
      splashImageUrl: "https://quto.dev/splash_pdf_to_html.png",
      icon: "/images/PDF-To-HTML-Converter.png"
    },
    {
      name: "PDF to Image Converter Online",
      nameKey: "pdf_to_image_name",
      description:
        "Convert PDF pages to high-resolution PNG or JPG images online. Create document previews and extract visual content.",
      descriptionKey: "pdf_to_image_desc",
      path: "/tools/pdf-to-image-converter",
      splashImageUrl: "https://quto.dev/splash_pdf_to_image.png",
      icon: "/images/PDF-To-Image-Converter.png"
    },
    {
      name: "PDF Page Splitter Online",
      nameKey: "pdf_splitter_name",
      description:
        "Split PDF files by selecting specific pages and downloading as a new PDF. Fast, secure, browser-based.",
      descriptionKey: "pdf_splitter_desc",
      path: "/tools/pdf-splitter",
      splashImageUrl: "https://quto.dev/splash_pdf_splitter.png",
      icon: "/images/PDF-Splitter.png"
    },
    {
      name: "PDF Compressor Online",
      nameKey: "pdf_compressor_name",
      description:
        "Compress PDF files online and reduce file size without losing quality. Processed entirely in your browser.",
      descriptionKey: "pdf_compressor_desc",
      path: "/tools/pdf-compressor",
      splashImageUrl: "https://quto.dev/splash_pdf_compressor.png",
      icon: "/images/PDF-Compressor.png"
    },
    {
      name: "Merge PDFs Online",
      nameKey: "pdf_merger_name",
      description:
        "Combine multiple PDF files into one document online. Drag to reorder, preview, and download — fully private and secure.",
      descriptionKey: "pdf_merger_desc",
      path: "/tools/pdf-merger",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Merge-PDFs.png"
    },
    {
      name: "Images to PDF Converter",
      nameKey: "images_to_pdf_name",
      description:
        "Combine JPG, PNG, WebP, and GIF images into a single PDF online. Reorder, choose page size and orientation, and download — 100% client-side and private.",
      descriptionKey: "images_to_pdf_desc",
      path: "/tools/images-to-pdf",
      splashImageUrl: "https://quto.dev/social_preview.jpg",
      icon: "/images/Images-To-PDF.png"
    },
  ],
  AUDIO: [
    {
      name: "Text to Speech Online",
      nameKey: "text_to_speech_name",
      description:
        "Convert text to natural-sounding speech with realistic AI voices in multiple languages.",
      descriptionKey: "text_to_speech_desc",
      path: "/tools/text-to-speech",
      loginRequired: true,
      isPaid: true,
      splashImageUrl: "https://quto.dev/splash_text_to_speech.png",
      icon: "/images/Text-To-Speech-Converter.png"
    },
    {
      name: "YouTube to MP3/MP4 Downloader",
      nameKey: "youtube_to_mp3_name",
      description:
        "Download YouTube videos as MP3 audio or MP4 video. Fast, high-quality conversion for offline listening.",
      descriptionKey: "youtube_to_mp3_desc",
      path: "/tools/youtube-downloader",
      loginRequired: true,
      isPaid: true,
      splashImageUrl: "https://quto.dev/splash_youtube_to_mp3.png",
      icon: "/images/YouTube-To-MP3.png"
    },
  ],
  VIDEO: [
    {
      name: "Online Screen Recorder",
      nameKey: "screen_recorder_name",
      description:
        "Record your screen directly in the browser — no software installation needed. Capture for demos, bugs, and tutorials.",
      descriptionKey: "screen_recorder_desc",
      path: "/tools/screen-recorder",
      loginRequired: true,
      isPaid: true,
      splashImageUrl: "https://quto.dev/splash_screen_recording.png",
      icon: "/images/Screen-Recorder.png"
    },
  ],
};
